import { render, staticRenderFns } from "./LogStandardTable.vue?vue&type=template&id=30488da1&scoped=true&"
import script from "./LogStandardTable.vue?vue&type=script&lang=js&"
export * from "./LogStandardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30488da1",
  null
  
)

export default component.exports